import {createAsyncThunk} from '@reduxjs/toolkit';
import {EntityToRename} from 'common/src/modules/shared/copilot/copilot.types';
import campaignsApi from 'common/src/modules/campaigns/campaigns.api';
import loadCampaignsLibraryData from './loadCampaignsLibraryData';
import {BreadcrumbName} from 'common/src/modules/breadcrumbs/breadcrumbs.enums';

export const renameCampaigns = createAsyncThunk(
  `${BreadcrumbName.CampaignsLibrary}/renameCampaigns`,
  async (entities: EntityToRename[], {dispatch}) => {
    await campaignsApi.renameCampaigns(entities);
    dispatch(loadCampaignsLibraryData());
  },
);
